export default __webpack_public_path__ + "static/media/AmericanExpress.c2c4cb71.svg";